import Excel from 'exceljs';
import * as FileSaver from 'file-saver';
import {SiMicrosoftexcel} from 'react-icons/si';
import Swal from 'sweetalert2';
import {apiPost} from '../../apis';
import {useMsal} from '@azure/msal-react';
import {formatDateTime} from '../../helpers/datetime';

export const ExportPaidSaleOrders = (props)=>{
  const {instance, accounts} = useMsal();

  const prepareSheetOne = ({workbook, exportData})=>{
    const sheet = workbook.addWorksheet('Sheet-1');

    const header = [
      'ORDERNUMBER',
      'CustAccount',
      'PurchOrderFormNum',
      'Site',
      'Quantity',
      'Total Price',
      'Order Date',
      'Payment Date (Paid)',
      'entry_id (OMISE Code)',
    ];

    const excelData = exportData?.map((d) => {
      return {
        'ORDERNUMBER': d?.orderNumber,
        'CustAccount': d?.employeeId,
        'PurchOrderFormNum': d?.orderNumber,
        'Site': d?.site || '',
        'Quantity': d?.qty || 0,
        'Total Price': d?.total?.toLocaleString('en-US', {minimumFractionDigits: 2}) || 0,
        'Order Date': d?.createdAt ? formatDateTime({dateTime: d?.createdAt, dateOnly: true, convertToThai: false}): '',
        'Payment Date (Paid)': d?.payment ? formatDateTime({dateTime: d?.payment?.updatedAt, dateOnly: true, convertToThai: false}) : '',
        'entry_id (OMISE Code)': d?.payment?.chargesId || '',
      };
    });

    sheet.addRow(header);
    for (const content of excelData) {
      sheet.addRow(Object.values(content));
    }

    sheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'cccccc'},
    };

    return workbook;
  };

  const exportExcel = () => {
    Swal.fire({
      title: 'Enter limit to export.',
      input: 'number',
      inputAttributes: {
        min: '1',
        autocapitalize: 'off',
      },
      inputValue: 1,
      confirmButtonText: 'Export',
      confirmButtonColor: 'green',
      showLoaderOnConfirm: true,
      didOpen: () => {
        const regExp = /^0[0-9].*$/;
        const input = Swal.getInput();
        input.oninput = (e) => {
          const limitInput = e.target.value;

          if (limitInput < 1 || regExp.test(limitInput)) {
            Swal.showValidationMessage(`Enter valid number!`);
          } else {
            Swal.resetValidationMessage();
          }
        };
      },
      inputValidator: (value) => {
        const regExp = /^0[0-9].*$/;

        if (value < 1 || regExp.test(value)) {
          return 'Enter valid number!';
        }
      },
      preConfirm: async (limit) => {
        try {
          let payload = props?.payloadForExcel || {};
          payload = {
            ...payload,
            limit: limit,
          };

          const json = await apiPost({
            uri: `Admin/order/paid`,
            payload: payload,
            msal: {
              instance: instance,
              accounts: accounts,
            },
          });

          return json;
        } catch (error) {
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (!result?.isConfirmed) return;

      const workbook = new Excel.Workbook();

      prepareSheetOne({workbook, exportData: result?.value?.orders || []});

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, 'paid_sales_order.xlsx');
      });
    });
  };

  return (
    <div className='d-flex align-items-center justify-content-center admin-btn admin-btn-green w-100' onClick={exportExcel}>
      <SiMicrosoftexcel size={'20px'} className='me-2'/>Export
    </div>
  );
};
